import routeParams from './routeParams'


/**
 * @namespace
 * @property {string} page
 * @property {string} pageType
 * @property {string} flow - net, org, facebook
 */
let context = {}

const setFromPath = (path: string): object => {
  context = routeParams[path] || {}

  if (typeof window !== 'undefined') {
    if (!window.__debug__) {
      window.__debug__ = {}
    }

    window.__debug__.snowplowContext = context
  }

  return context
}

const set = (values: any) => context = values
const get = () => context


export default {
  setFromPath,
  set,
  get,
}
